export const WindyMapBlockIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 512 512">
		<defs>
			<style>{ '.st1{fill:#f26c0d}' }</style>
		</defs>
		<path
			d="M448 1.5H64C29.5 1.5 1.5 29.5 1.5 64v384c0 34.5 28 62.5 62.5 62.5h384c34.5 0 62.5-28 62.5-62.5V64c0-34.5-28-62.5-62.5-62.5ZM465.5 448c0 9.6-7.9 17.5-17.5 17.5H64c-9.6 0-17.5-7.9-17.5-17.5V64c0-9.6 7.9-17.5 17.5-17.5h384c9.6 0 17.5 7.9 17.5 17.5v384Z"
			className="st1"
		/>
		<path
			d="M295.9 364.8c-4.4.5-8.9 0-13.1-1.2 20.8-18.3 36.7-41.6 49.2-66.2 19.3-38.4 36.3-77.7 51.5-117.6-18.8 38.3-39.3 75.8-61.7 111.8-14.5 23-32.4 44.7-54.9 60-13.1-17.2-16.7-45.8-18.9-65.8-4.6-44.8-4.4-90-.5-134.7 1.2-13.6-9.8-25.6-23.5-25.4-12.9.1-23.3 10.7-23.2 23.6.4 42.2 3.8 84.5 11.2 126 3.7 20.5 7.7 41.9 16.4 62.9 3.5 8.4 7.8 16.7 13.3 24.1-22 .8-40.2-24.6-48.9-42.8-2.8-6-5.2-12.1-7.1-18.5-5.2-16.5-8.1-34.6-10.5-52-4.5-33.7-5.6-67.2-6.1-101.4-.1-13.7-12.3-24.5-25.9-22.9-12.9 1.4-22.2 12.9-20.8 25.8 2.3 21.4 4.8 43 8.3 64.7 4.5 27.3 10.2 54.5 18.8 80.9 4.1 12.3 9.2 24.6 15.7 35.9 15.4 26.8 43.6 56.5 77.2 53.1 6.3-.7 12.3-2.5 17.9-5.2.5.3 1 .7 1.6 1 16.9 9.9 39.3 8.9 55.5-1.5 10-6.3 17.8-14.9 24.4-24.3 9.3-13.5 15.8-27.7 21.9-42.5 18-42.9 30.6-87.7 42.2-132.5-17.6 48.2-36 95.8-61.4 140.2-11 18.4-26.2 41.7-48.4 44.8Z"
			className="st1"
		/>
	</svg>
);

export const WindyMapPreview = () => (
	<div
		style={ {
			width: '100%',
			height: '320px',
			display: 'grid',
			placeItems: 'center',
		} }
	>
		<iframe
			src="https://embed.windy.com/embed.html?lat=51.509865&lon=-0.118092&zoom=4"
			style={ { width: '100%', height: '100%' } }
		/>
	</div>
);
